// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GoBackButton_wrapper__41xn_"};